import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import { useLabels, useRequestData, usePrefs } from 'wsm-common-data';
import Poster from '../components/Poster';
import Awards from '../components/Awards';
import Stories from '../components/Stories';
import Dedication from '../components/Dedications';
import Badge from '../components/Badges';
import ShareModal from '../components/Share/ShareModal';
import SharePanel from '../components/Share/SharePanel';
import ShareFooter from '../components/Share/ShareFooter';

const Widget = () => {
	const { dealerData, optIns, stories, accountInfo } = useSelector(
		(state) => state
	);
	const [showStoryModal, setShowStoryModal] = useState(false);
	const [showStorySubmitFooter, setShowStorySubmitFooter] = useState(false);
	const [lockStorySubmitFooter, setlockStorySubmitFooter] = useState(false);
	const { lpHeartImageUrl } = usePrefs();

	const handleLockSubmitFooter = () => {
		setlockStorySubmitFooter(true);
	};

	const handleUnlockSubmitFooter = () => {
		setlockStorySubmitFooter(false);
	};

	const handleShowStoryFooter = () => {
		setShowStorySubmitFooter(true);
	};
	const handleHideStoryFooter = () => {
		setShowStorySubmitFooter(false);
	};

	const handleShowStoryModal = () => {
		setShowStoryModal(true);
	};

	const handleCloseStoryModal = () => {
		setShowStoryModal(false);
	};

	const requestData = useRequestData();
	const labels = useLabels();
	const isDealerData =
		typeof dealerData?.dealerData === 'object' &&
		dealerData?.dealerData != null;

	return (
		<div>
			{isDealerData && (
				<Awards
					dealerData={dealerData}
					deviceType={requestData.deviceType}
				/>
			)}
			<div className="row mb-4">
				<div className="col-sm-8">
					<img
						className="my-4 mx-auto visible-xs"
						src={lpHeartImageUrl}
						alt={labels.get('SUBARU_LOVE_PROMISE_HEART')}
					/>
					<Badge
						deviceType={requestData.deviceType}
						accountName={accountInfo.name}
					/>
					{optIns &&
						optIns.optIns &&
						Object.keys(optIns.optIns).length > 0 && (
							<Dedication
								optinData={optIns}
								name={accountInfo.name}
								deviceType={requestData.deviceType}
							/>
						)}
				</div>
				<div className="col-sm-4">
					<img
						className="my-4 hidden-xs"
						src={lpHeartImageUrl}
						alt={labels.get('SUBARU_LOVE_PROMISE_HEART')}
					/>
					{optIns &&
						optIns.optIns &&
						Object.keys(optIns.optIns).length > 0 && (
							<div className="mb-4 hidden-xs">
								<Poster optinData={optIns} />
							</div>
						)}
					<SharePanel
						accountInfo={accountInfo}
						deviceType={requestData.deviceType}
						openModal={handleShowStoryModal}
						showFooter={handleShowStoryFooter}
						hideFooter={handleHideStoryFooter}
					/>
				</div>
			</div>
			<React.Fragment>
				<ShareModal
					labels={labels}
					accountInfo={accountInfo}
					show={showStoryModal}
					handleClose={handleCloseStoryModal}
				/>
				{stories.length > 0 && (
					<Stories
						labels={labels}
						stories={stories}
						accountInfo={accountInfo}
						deviceType={requestData.deviceType}
						lockFooter={handleLockSubmitFooter}
						unlockFooter={handleUnlockSubmitFooter}
					/>
				)}
				<ShareFooter
					labels={labels}
					accountInfo={accountInfo}
					deviceType={requestData.deviceType}
					openModal={handleShowStoryModal}
					show={showStorySubmitFooter}
					lock={lockStorySubmitFooter}
				/>
			</React.Fragment>
		</div>
	);
};

export default Widget;
